import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { IShow } from '../interfaces/IShow';
import { ShowsService } from '../services/ShowsService';
import { ShowsStore } from '../stores/ShowsStore';
import dayjs from 'dayjs';

export const showsResolver: ResolveFn<IShow[]> = () => {
  inject(ShowsStore).shows.set([]);

  return inject(ShowsService).getProgram(dayjs())
    .pipe(map(res => res.data));
};
